export default "__VITE_ASSET__DdnA8Js2__"